import React from 'react';
import styled, { css } from 'styled-components';
import storeAvatar from '@images/svg/shop.svg';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Mixins } from 'planoplan-ui-kit/core/mixins';

export const WidgetCabinetButton = ({ avatar, children, href, onClick }) => (
  <WrapperButton>
    <CabinetLink href={href} data-test="widget__button-cabinet">
      {children}
    </CabinetLink>
    <Avatar onClick={onClick} image={avatar} data-test="widget__button-user" />
  </WrapperButton>
);

export const WidgetStoreButton = ({ children, ...restProps }) => (
  <CabinetLinkButton {...restProps} data-test="widget__button-store">
    <ButtonText>{children}</ButtonText>
    <Icon>
      <img src={storeAvatar} alt="store" />
    </Icon>
  </CabinetLinkButton>
);

export const WidgetLoginButton = ({ children, ...restProps }) => (
  <CabinetLinkButton {...restProps}>
    <ButtonText>{children}</ButtonText>
  </CabinetLinkButton>
);

const buttonCss = css`
  ${Mixins.transition('background-color')};
  height: 40px;
  background-color: ${Colors.night};
  color: ${Colors.white};
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding-left: 15px;
  border: none;
  font-size: 18px;
  font-weight: 300;
  cursor: pointer;
  text-decoration: none;
  box-sizing: border-box;
  outline: none;

  &:hover {
    color: ${Colors.white};
    background-color: ${Colors.night};
  }
`;

const WrapperButton = styled.div`
  position: relative;
`;

export const WidgetButtons = styled.div`
  display: flex;
  align-items: center;
`;

export const CabinetLink = styled.a`
  ${buttonCss};
  padding-right: 48px;
`;

const CabinetLinkButton = styled.a`
  ${buttonCss};
  padding-right: 2px;
  margin-right: 2px;
`;

const ButtonText = styled.span`
  flex-grow: 1;
  padding-right: 15px;
`;

const Icon = styled.div`
  margin-right: 12px;
`;

const Avatar = styled.button`
  ${Mixins.resetButton()};
  ${Mixins.transition('opacity')};
  position: absolute;
  top: 2px;
  right: 2px;
  width: 36px;
  height: 36px;
  background-color: ${Colors.light_gray};
  border-radius: 4px;
  background-image: ${(p) => (p.image ? `url(${p.image})` : 'none')};
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;

  &:hover {
    opacity: 0.9;
  }
`;
